export default "__VITE_ASSET__CzU0iSb7__"